import { render } from "./PlayIcon.vue?vue&type=template&id=0e6f9b62"
import script from "./PlayIcon.vue?vue&type=script&lang=js"
export * from "./PlayIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__